import { StreamingWidgetState } from 'widgets/store/stream/WidgetStreamState';
import { OpenSubmissionsDataState } from 'widgets/openSubmissions/store/stream/OpenSubmissionsStreamDataState';

export type OpenSubmissionsCapsuleWidgetState =
    StreamingWidgetState<OpenSubmissionsDataState>;

export interface OpenSubmissionsCapsuleWidgetsState {
    [widgetId: string]: OpenSubmissionsCapsuleWidgetState;
}

export const initialOpenSubmissionsCapsuleWidgetsState: OpenSubmissionsCapsuleWidgetsState =
    {};
